import { reactive, readonly } from 'vue';
import type { ExamSubject } from '@/views/home/exam-data';
import { isLogin, gotoLogin } from '@/utils/auth';

// 报名弹窗全局状态：任意位置可触发 openReg(subject?)，由 app.vue 挂载的 RegDialogHost 统一渲染。
interface RegDialogState {
  open: boolean;
  lockOpen: boolean;
  subject: ExamSubject | null;
}

const state = reactive<RegDialogState>({ open: false, lockOpen: false, subject: null });

export function useRegDialog() {
  function openReg(subject: ExamSubject | null = null) {
    // 报名需登录，未登录触发 OAuth 登录
    if (!isLogin()) {
      gotoLogin();
      return;
    }

    state.subject = subject;
    state.open = true;
  }

  function closeReg() {
    state.open = false;
    state.subject = null;
  }

  function setSubject(subject: ExamSubject | null) {
    state.subject = subject;
  }

  // 报名提交后弹出锁定确认
  function openLock() {
    state.open = false;
    state.lockOpen = true;
  }

  function closeLock() {
    state.lockOpen = false;
  }

  return {
    state: readonly(state),
    openReg,
    closeReg,
    setSubject,
    openLock,
    closeLock,
  };
}
